<template>
  <section v-bind="$attrs" class="company-culture">
    <div class="company-title-wrap">
      <h4 class="company-title">{{ $t('menuCompany.woowaCulture') }}</h4>
    </div>

    <div class="company-box vision" :data-id="$t('vision.name')">
      <h5 :id="$t('vision.name')">{{ $t('vision.name') }}</h5>
      <div class="company-box-image">
        <p>
          <picture class="tab-image mobile-active" :class="{active: vision === 3}">
            <source media="(min-width: 750px)" srcset="~@/static/image/company/pc/image_vision_3@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/company/m/image_vision_3@3x.jpg 3x">
            <img src="~@/static/image/company/pc/image_vision_3.jpg" :alt="$t('vision.name')">
          </picture>
          <picture class="tab-image" :class="{active: vision === 2}">
            <source media="(min-width: 750px)" srcset="~@/static/image/company/pc/image_vision_2@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/company/m/image_vision_2@3x.jpg 3x">
            <img src="~@/static/image/company/pc/image_vision_2.jpg" :alt="$t('vision.name')">
          </picture>
          <picture class="tab-image" :class="{active: vision === 1}">
            <source media="(min-width: 750px)" srcset="~@/static/image/company/pc/image_vision_1@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/company/m/image_vision_1@3x.jpg 3x">
            <img src="~@/static/image/company/pc/image_vision_1.jpg" :alt="$t('vision.name')">
          </picture>
        </p>
      </div>
      <html-view :value="$t('vision.title')" class="company-box-title" />
      <div class="company-box-content">
        <div class="vision-tab">
          <div class="nav-tabs">
            <button type="button" :class="{active: vision === 3}" @click="onChangeVision(3)">{{ $t('vision.tab3.menu') }}</button>
            <button type="button" :class="{active: vision === 2}" @click="onChangeVision(2)">{{ $t('vision.tab2.menu') }}</button>
            <button type="button" :class="{active: vision === 1}" @click="onChangeVision(1)">{{ $t('vision.tab1.menu') }}</button>
          </div>
          <div class="nav-item-wrap">
            <div class="nav-item" :class="{active: vision === 3}">
              <div class="vision-version">{{ $t('vision.tab3.menu') }}</div>
              <div class="vision-content">
                <html-view :value="$t('vision.tab3.title')" class="vision-content-title" />
                <html-view :value="$t('vision.tab3.content')" />
                <time>{{ $t('vision.tab3.date') }}</time>
              </div>
            </div>
            <div class="nav-item" :class="{active: vision === 2}">
              <div class="vision-image">
                <p>
                  <picture>
                    <source media="(min-width: 750px)" srcset="~@/static/image/company/pc/image_vision_2@3x.jpg 3x">
                    <source media="(max-width: 750px)" srcset="~@/static/image/company/m/image_vision_2@3x.jpg 3x">
                    <img src="~@/static/image/company/pc/image_vision_2.jpg" :alt="$t('vision.name')">
                  </picture>
                </p>
              </div>
              <div class="vision-version">{{ $t('vision.tab2.menu') }}</div>
              <div class="vision-content">
                <html-view :value="$t('vision.tab2.title')" class="vision-content-title" />
                <html-view :value="$t('vision.tab2.content')" />
                <time>{{ $t('vision.tab2.date') }}</time>
              </div>
            </div>
            <div class="nav-item" :class="{active: vision === 1}">
              <div class="vision-image">
                <p>
                  <picture>
                    <source media="(min-width: 750px)" srcset="~@/static/image/company/pc/image_vision_1@3x.jpg 3x">
                    <source media="(max-width: 750px)" srcset="~@/static/image/company/m/image_vision_1@3x.jpg 3x">
                    <img src="~@/static/image/company/pc/image_vision_1.jpg" :alt="$t('vision.name')">
                  </picture>
                </p>
              </div>
              <div class="vision-version">{{ $t('vision.tab1.menu') }}</div>
              <div class="vision-content">
                <html-view :value="$t('vision.tab1.title')" class="vision-content-title" />
                <html-view :value="$t('vision.tab1.content')" />
                <time>{{ $t('vision.tab1.date') }}</time>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="company-box value" :data-id="$t('value.name')">
      <h5 :id="$t('value.name')">{{ $t('value.name') }}</h5>
      <div class="company-box-image">
        <p>
          <picture>
            <source media="(min-width: 750px)" srcset="~@/static/image/company/pc/image_value@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/company/m/image_value@3x.jpg 3x">
            <img src="~@/static/image/company/pc/image_value.jpg" :alt="$t('value.name')">
          </picture>
        </p>
      </div>
      <html-view :value="$t('value.title')" class="company-box-title" />
      <div class="company-box-content">
        <ul class="value-list">
          <li>
            <div class="value-list-title">{{ $t('value.list.item1.title') }}</div>
            <div>{{ $t('value.list.item1.content') }}</div>
          </li>
          <li>
            <div class="value-list-title">{{ $t('value.list.item2.title') }}</div>
            <div>{{ $t('value.list.item2.content') }}</div>
          </li>
          <li>
            <div class="value-list-title">{{ $t('value.list.item3.title') }}</div>
            <div>{{ $t('value.list.item3.content') }}</div>
          </li>
          <li>
            <div class="value-list-title">{{ $t('value.list.item4.title') }}</div>
            <div>{{ $t('value.list.item4.content') }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="company-box people" :data-id="$t('people.name')">
      <h5 :id="$t('people.name')">{{ $t('people.name') }}</h5>
      <div class="company-box-image">
        <p>
          <picture>
            <source media="(min-width: 750px)" srcset="~@/static/image/company/pc/image_people@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/company/m/image_people@3x.jpg 3x">
            <img src="~@/static/image/company/pc/image_people.jpg" :alt="$t('people.name')">
          </picture>
        </p>
      </div>
      <html-view :value="$t('people.title')" class="company-box-title" />
      <div class="company-box-content">
        <ul class="people-list">
          <li>
            <div class="people-list-title">{{ $t('people.list.item1.title') }}</div>
            <div>{{ $t('people.list.item1.content') }}</div>
          </li>
          <li>
            <div class="people-list-title">{{ $t('people.list.item2.title') }}</div>
            <div>{{ $t('people.list.item2.content') }}</div>
          </li>
          <li>
            <div class="people-list-title">{{ $t('people.list.item3.title') }}</div>
            <div>{{ $t('people.list.item3.content') }}</div>
          </li>
          <li>
            <div class="people-list-title">{{ $t('people.list.item4.title') }}</div>
            <div>{{ $t('people.list.item4.content') }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="company-box better" :data-id="$t('better.name')">
      <h5 :id="$t('better.name')">{{ $t('better.name') }}</h5>
      <html-view :value="$t('better.title')" class="company-box-title" />
      <div class="company-box-content">
        <html-view :value="$t('better.paragraph')" class="paragraph" />
        <div class="better-image">
          <picture>
            <source media="(min-width: 750px)" srcset="~@/static/image/company/pc/image_better@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/company/m/image_better@3x.jpg 3x">
            <img src="~@/static/image/company/pc/image_better.jpg" :alt="$t('better.name')">
          </picture>
        </div>
        <div class="better-download">
          <div class="link-select">
            <button
              class="link-select-button"
              type="button"
              :class="{
                'link-select-active': isBetterShow
              }"
              @click="onBetterToggle"
            >
              <span>{{ $t('better.download.title') }}</span>
              <span class="down"><icon-chevron-down /></span>
            </button>
            <transition name="link-select">
              <ul v-if="isBetterShow" class="link-select-list">
                <li>
                  <a :href="require('@/static/download/poster_RGB.jpeg')" download target="_blank">{{ $t('better.download.imageKr') }}</a>
                </li>
                <li>
                  <a :href="require('@/static/download/poster_CMYK.pdf')" download target="_blank">{{ $t('better.download.pdfKr') }}</a>
                </li>
                <li>
                  <a :href="require('@/static/download/poster_RGB_eng.jpg')" download target="_blank">{{ $t('better.download.imageEn') }}</a>
                </li>
                <li>
                  <a :href="require('@/static/download/poster_CMYK_eng.pdf')" download target="_blank">{{ $t('better.download.pdfEn') }}</a>
                </li>
              </ul>
            </transition>
          </div>
        </div>
        <ol class="better-list">
          <li>
            <html-view :value="$t('better.list.item1.title')" class="better-list-title" />
            <div>{{ $t('better.list.item1.content') }}</div>
          </li>
          <li>
            <html-view :value="$t('better.list.item2.title')" class="better-list-title" />
            <div>{{ $t('better.list.item2.content') }}</div>
          </li>
          <li>
            <html-view :value="$t('better.list.item3.title')" class="better-list-title" />
            <div>{{ $t('better.list.item3.content') }}</div>
          </li>
          <li>
            <html-view :value="$t('better.list.item4.title')" class="better-list-title" />
            <div>{{ $t('better.list.item4.content') }}</div>
          </li>
          <li>
            <html-view :value="$t('better.list.item5.title')" class="better-list-title" />
            <div>{{ $t('better.list.item5.content') }}</div>
          </li>
          <li>
            <html-view :value="$t('better.list.item6.title')" class="better-list-title" />
            <div>{{ $t('better.list.item6.content') }}</div>
          </li>
          <li>
            <html-view :value="$t('better.list.item7.title')" class="better-list-title" />
            <div>{{ $t('better.list.item7.content') }}</div>
          </li>
          <li>
            <html-view :value="$t('better.list.item8.title')" class="better-list-title" />
            <div>{{ $t('better.list.item8.content') }}</div>
          </li>
          <li>
            <html-view :value="$t('better.list.item9.title')" class="better-list-title" />
            <div>{{ $t('better.list.item9.content') }}</div>
          </li>
          <li>
            <html-view :value="$t('better.list.item10.title')" class="better-list-title" />
            <div>{{ $t('better.list.item10.content') }}</div>
          </li>
          <li>
            <html-view :value="$t('better.list.item11.title')" class="better-list-title" />
            <div>{{ $t('better.list.item11.content') }}</div>
          </li>
        </ol>
      </div>
    </div>
  </section>
</template>
<script>

export default {
  components: {
    iconChevronDown: () => import('@/static/svg/chevron-down.svg'),
  },
  data () {
    return {
      isBetterShow: false,
      vision: 3
    }
  },
  mounted () {
    this.$emit('loaded:component')
    // this.initObserver(this.$el.querySelectorAll('section'))
  },
  methods: {
    onBetterToggle () {
      this.isBetterShow = !this.isBetterShow

      const docEvents = (e) => {
        if (!e.target.closest('.link-select')) {
          this.isBetterShow = false
          document.documentElement.removeEventListener('click', docEvents)
        }
      }

      document.documentElement.addEventListener('click', docEvents)
    },
    onChangeVision (index) {
      this.vision = index
    }
  }
}
</script>
